<template>
	<div class="prize-winners-report-table-wrapper" v-if="data">
		<v-data-table class="mb-2" :headers="reportHeaders(data.headers)" :items="Object.values(data.winners).sort((a, b) => a.seqNo - b.seqNo)" :hide-actions="true" :loading="loading">
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template slot="items" slot-scope="props">
				<template v-for="(value, key) in props.item" v-if="key != 'userId'">
					<td v-if="key == 'username'">
						<a :href="`https://www.jeban.com/mypage/${props.item.userId}`" target="_blank" v-html="value"></a>
					</td>
					<td class="text-xs-center" v-else-if="key.substring(0, 7) == 'product'">
						<a v-if="value && value.hasOwnProperty('id')" :href="`https://daisy.jeban.com/review/${value.id}`" target="_blank" v-html="value.publishedOn.substring(0, 10)"></a>
						<span v-else>&nbsp;</span>
					</td>
					<td class="review-topic-td" width="250" v-else-if="key == 'topic'">
						<template v-if="value && value.hasOwnProperty('id')">
							<span v-html="value.type"></span>
							<a :href="`https://www.jeban.com/topic/${value.id}`" target="_blank">{{ value.title }}</a>
							<small v-html="` (${value.publishedOn.substring(0, 10)})`"></small>
						</template>
						<template v-else>&nbsp;</template>
					</td>
					<td class="text-xs-right" v-else-if="['seqNo'].includes(key)" v-html="value"></td>
					<td class="text-xs-center" v-else-if="['status'].includes(key)" v-html="value"></td>
					<td v-else v-html="value"></td>
				</template>
			</template>
			<template slot="no-data">
				<v-btn color="primary" @click="handlePageChange(1)">Reset</v-btn>
			</template>											
		</v-data-table>

		<performance-csv :prize-id="data.id" :color="'secondary'" :file-title="`prize-${data.id}-performance`">Export</performance-csv>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import PerformanceCsv from '@/components/PrizePerformanceCsv.vue'

	export default {
		components: {
			'performance-csv': PerformanceCsv
		},
		props: {
			data: {
				type: Object,
				default: () => null
			}
		},
		data () {
			return {
				loading: false
			}
		},
		methods: {
			reportHeaders (headers) {
				return headers.filter(h => h != 'MemberId').map(h => {
					return {
						text: h,
						align: h == 'No.' ? 'right' : 'left',
						sortable: false }
					})
			}
		}
	}
</script>

<style lang="scss">
	.prize-winners-report-table-wrapper {
		width: 100%;
		overflow-x: auto;

		table {
			table-layout: fixed;
			width: unset !important;
			max-width: unset !important;

			thead {
				th {
					text-align: center !important;
					white-space: normal;
					width: 200px;

					&:nth-of-type(1) {
						text-align: right !important;
						width: 75px;
					}
					&:nth-of-type(3) {
						width: 100px;
					}
					&:nth-of-type(4) {
						width: 250px;
					}
				}
			}
			thead, tbody {
				th, td {
					&:not(:last-of-type) {
						border-right: 1px solid #eee;
					}
				}
			}
			tbody {
				.review-topic-td {
					a {
						display: block;
						text-decoration: none;
					}
					span {
						background: #ccc;
						border-radius: 4px;
						font-size: 8pt;
						background: #999;
						color: white;
						padding: 2px 4px;
					}
					small {
						color: black;
					}
				}
			}
		}
	}
</style>
